const Form082EN = {
    stepName: {
        importantNotes: "Important Notes",
        basicInformation: "Basic Information",
        declaration: "Declaration",
        confirmation: "Confirmation",
    },
    tooltipList: {
        toopltip1:
            "1. The maximum number of days for paternity leave is 5 working days. For details of approving paternity leave, please refer to EDBC No.16/2015.",
        toopltip2: "Please delete as appropriate.",
    },
    importantNotesContent: {
        // note: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        // a: "processing employment-related matters;",
        // b: "processing payment of Salaries Grant and other government funding;",
        // c: "calculation of provident fund contribution;",
        // d: "auditing;",
        // e: "conducting research and compiling statistics to facilitate planning of education services;",
        // f: "processing matters relating to the development of the education profession;",
        // g: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        // note1: "The provision of personal data by means of this form is obligatory. Failure to provide these data may affect the processing and outcome of your application.",
        // note2: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        // note3: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        // note4: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
        title: "Personal Information Collection Statement",
        p_title: "Purpose of Collection",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_a: "Activities relating to the processing, authentication and counter-checking of the application for Reimbursement of Paternity Leave (Applicable to Staff Already Ceased Employment Only);",
        p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
        p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant / Subsidized Schools Provident Fund Rules) and the Codes of Aid.",

        p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

        p_title3: "Classes of Transferees",
        p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        p3_a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above; ",
        p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        p3_c: "where you have given your prescribed consent to such disclosure; and",
        p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

        p_title4: "Access to Personal Data",
        p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to the respective Senior School Development Officer by post to the Regional Education Office at the address on the EDB website (https://www.edb.gov.hk/en/contact-us/reo.html) or email to <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>.",

        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        iamStatement:
            "I understand the approving authority of the school need to have an “iAM Smart+” account to process the application.",
    },
    schoolInformation: {
        title: "School Information",

        label: {
            nameOfSchool: "Name of School",
            schoolCode: "School Code",
            month: "Month",
            year: "Year",
        },
    },
    basicInformationContent: {
        title: "A. Basic Information",
        paternityLeaveTitle: "Teaching / Non-Teaching Staff",
        applicantTitle: "Paternity Leave Period",
        salaryTitle: "Salary",
        label: {
            name: "Name",
            staffRefNo: "Staff Reference Number",
            post: "Post",
            cesssationOfEmploymentDate: "Date of Cessation of Employment",
            paternityLeaveFrom: "From",
            paternityLeaveTo: "To",
            noOfworkingDays: "No. of Working Days (a)",
            monthlySalary: "Monthly Salary ($)(b)",
            dailySalary:
                "Daily Salary($)(c) = (b) ÷ Number of Days of that Month",
            totalAmountPerRow:
                "Total Amount of Reimbursement($)(d) = (c) x (a)",
            total: "Total($)",
            leaveType: "No-pay Leave / Annual Leave",
            leaveOption: {
                noPay: "No-pay Leave",
                annual: "Annual Leave ",
            },
            emolumentsAttachment: "Attachment for the Emoluments",
            otherAttachment:
                "Other Attachment(s) (i.e. covering letter from school, resignation letter, certification of birth, date of confinement, date of paternity leave granted, etc.)",
        },
    },
    declarationContent: {
        title: "B. Declaration",
        label: {
            applicantType: "Supervisor / School Head",
            applicantTypeOption: {
                supervisor: "Supervisor",
                schoolHead: "School Head",
            },
            applicantName: "Name of ",
            claimDate: "Claim Date",
            contactPersonName: "Contact Person",
            telNo: "Tel No.",
            ssdo: "SSDO",
            beforeSSDOText: "c.c.︰SSDO( ",
            afterSSDOText: ")",
        },
        subTitle: "I certify that –",
        textBeforeTooltip2:
            "the school has processed the application for paternity leave of the staff concerned in accordance with the related circular. His paternity leave has been covered by ",
        textAfterTooltip2:
            " due to failure of submission of documentary proof earlier. He has subsequently submitted the documentary proof and has been verified by the school.",
        p2: "the emoluments have been paid to the staff concerned; relevant receipts being attached for your record.",
    },
    errorMsg: {
        label: {
            noOfworkingDays: "No. of Working Days",
            monthlySalary: "Monthly Salary",
            dailySalary: "Daily Salary",
        },
    },
};
export default Form082EN;
